import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private _authService: AuthService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return this._authService.jwt().pipe(
            switchMap((jwt: string) => {
                const newReq = req.clone({
                    headers: jwt ? req.headers.set('Authorization', `Bearer ${jwt}`) : req.headers,
                });
                return next
                    .handle(newReq)
                    .pipe(
                        catchError((error: any) =>
                            this.handleUnauthorizedError(error)
                        )
                    );
            })
        );
    }

    private handleUnauthorizedError(error): Observable<never> {
        if (error instanceof HttpErrorResponse && error.status === 401) {
            this._authService.signOut();
            location.reload();
        }
        return throwError(error);
    }
}
